import { render, staticRenderFns } from "./petit-haut-lafitte.vue?vue&type=template&id=617639ac&scoped=true"
import script from "./petit-haut-lafitte.vue?vue&type=script&lang=js"
export * from "./petit-haut-lafitte.vue?vue&type=script&lang=js"
import style0 from "./petit-haut-lafitte.vue?vue&type=style&index=0&id=617639ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617639ac",
  null
  
)

export default component.exports